module.exports = __webpack_public_path__ + "static/dummy-profile-1f436c379284cbfb7463fc14d9c84e92.jpg";